<div class="py-1"></div>
<div class="card">
  <h6 class="card-header" style="cursor: pointer" (click)="showNewTagForm = !showNewTagForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewTagForm, 'fa-minus-circle': showNewTagForm }"></i>&nbsp;New Tag</h6>
  <div class="card-body" [hidden]="!showNewTagForm" style="max-height: 340px; overflow-y: scroll">
    <div class="form-group">
      <label>Tag</label>
      <input type="text" class="form-control form-control-sm" required name="newTag" ngDefaultControl [(ngModel)]="newTag" />
    </div>
    <div class="form-row">
      <div class="col-6">
        <button type="button" class="btn btn-sm btn-primary btn-block" (click)="addTag()">Add</button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-sm btn-secondary btn-block" (click)="showNewTagForm = false">Cancel</button>
      </div>
    </div>
  </div>
</div>
<div class="py-1"></div>
<div class="float-right">
  <button type="button" [disabled]="tags_loading" (click)="loadTags()" class="btn btn-outline-primary btn-sm">
    <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': tags_loading }"></i>
  </button>
</div>
<div class="clearfix"></div>
<div class="py-1"></div>
<table class="table table-sm">
  <tbody>
    <tr *ngFor="let tag of tags; let i = index">
      <td>
        {{ tag }}
      </td>
      <td>
        <a class="pull-right float-right text-danger" href="javascript: void(0)" (click)="removeTag(tag, i)"><i class="fas fa-trash"></i></a>
      </td>
    </tr>
  </tbody>
</table>
